import type {ReactNode} from "react";
import React from "react";
import {Alert, Button, CircularProgress, Grid, Tooltip, Typography} from "@mui/material";
import {Check, Close} from "@mui/icons-material";

// TODO: Move this to a more generic component and set the ID field properly
export const EditorModalComponent: React.FC<{
    titleId: string
    className?: string
    saveLabel?: string
    onSave: () => void
    canSave: boolean
    saveTooltip?: string
    isSaving?: boolean
    hideCancel?: true
    cancelLabel?: string
    onCancel?: () => void
    title: string | null
    titleIcon?: ReactNode
    onClose: () => void
    isError?: boolean | string,
    largerErrorMessages?: boolean,
    children?: ReactNode,
}> = ({
          titleId,
          className,
          saveLabel,
          onSave,
          canSave,
          saveTooltip,
          isSaving,
          hideCancel,
          cancelLabel,
          onCancel,
          onClose,
          title,
          titleIcon,
          isError,
          largerErrorMessages,
          children
      }) => {
    const saveButton = <Button
        disabled={!canSave || isSaving}
        fullWidth
        startIcon={isSaving ? <CircularProgress size={12}/> : <Check/>}
        onClick={onSave}
        variant="outlined"
        // tabIndex="2"
    >{saveLabel || 'Save'}</Button>;
    return <Grid container className={"edit-model-component" + (className ? ' ' + className : '')}>
        <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="stretch"
            spacing={3}
            size={8}>
            {title !== null && <Grid>
                <Typography id={titleId} variant="h5">
                    {titleIcon}&nbsp;
                    {title}
                </Typography>
            </Grid>}
            {isError && largerErrorMessages && <>
                <Grid>
                    <Alert severity="error">
                        {typeof isError === 'string'
                            ? isError
                            : 'Error'}
                    </Alert>
                </Grid>
            </>}
            <Grid>
                {children}
            </Grid>
        </Grid>
        <Grid size={2}/>
        <Grid
            alignItems="stretch"
            container
            direction="column"
            justifyContent="space-between"
            size={2}>
            <Grid>
                {!hideCancel &&
                    <Button
                        fullWidth
                        className="btn-red"
                        startIcon={<Close/>}
                        onClick={() => {
                            if (onCancel) onCancel();
                            else onClose();
                        }}
                        variant="outlined"
                    >
                        {cancelLabel !== undefined ? cancelLabel : 'Cancel'}
                    </Button>
                }
            </Grid>
            {isError && !largerErrorMessages && <>
                <Grid container>
                    <Grid>
                        <Alert severity="error">
                            {typeof isError === 'string'
                                ? isError
                                : 'Error'}
                        </Alert>
                    </Grid>
                </Grid>
            </>}
            <Grid>
                {saveTooltip ? <Tooltip title={saveTooltip}><span>{saveButton}</span></Tooltip> : saveButton}
            </Grid>
        </Grid>
    </Grid>;
}
